import { api, endpoint } from '@/plugins/axios'

const getHolidays = async () => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.get(`${endpoint.HOLIDAY}/all`, { params: { institutionId } })

  return res
}

const createHoliday = async payload => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.post(endpoint.HOLIDAY, { institutionId, ...payload })

  return res
}

const updateHoliday = async payload => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.put(endpoint.HOLIDAY, { institutionId, ...payload })

  return res
}

const deleteHoliday = async holidayId => {
  const res = await api.delete(`${endpoint.HOLIDAY}/${holidayId}`)

  return res
}

export default {
  getHolidays,
  createHoliday,
  updateHoliday,
  deleteHoliday,
}
